module.exports = __webpack_public_path__ + "img_senzoku_03.bfb3f2b691d2c0e27416.png";